import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import router from './router'
import App from './App.vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '@/utils/permission'
import api from "@/lib/api"
import store from './store'

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.prototype.$api = api

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
